export const calculateLoanThreshold = ({ loanAmount }) => (
  Math.ceil(loanAmount * 60) / 100
);
